import { Loader } from '@/app/components/ui/loader';
import { cn } from '@/app/utils';

/**
 * 带定位的全局 loader
 * 默认居中显示，top 50vh，left 1/2
 * 如果不需要定位，请直接使用 Loader 组件
 */
export function GlobalLoader({ className }: { className?: string }) {
  return <Loader className={cn('-translate-x-1/2 -translate-y-1/2 absolute top-[50vh] left-1/2', className)} />;
}
